import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import pdf from '../images/collection-pdf.png';
import { useContext } from 'react';
import { SearchContext } from './Contexts/Context';
import SakrebuloActs from './SakrebuloActs';
import SakrebuloActsList from './SakrebuloActsList';
function BiurosOqmebi() {
	const ref = useRef(null);
	const [width, setWidth] = useState(10);

	// import { useContext } from 'react'
	//import { SearchContext } from './Contexts/Context'
	// .filter(news => news[1].geo.pdf_title.includes(search))
	const { search } = useContext(SearchContext);
	const { language } = useContext(SearchContext);
	const [news, setNews] = useState({});

	const [menu, setMenu] = useState({});
		const [actList, setActList]= useState('')



	useLayoutEffect(() => {
		setWidth(ref.current.offsetWidth);
	});
	const menuName = Object.entries(menu).length
		? Object.entries(menu).find((item, index) => {
				const windoww = window.location.pathname;
				const result = windoww.split('/').pop();
				const slugg = item[1].slug;
				if (result === slugg) {
					return language == 1 ? item[1].name_geo : item[1].name_eng;
				}
		  })
		: '';

	return (
		<motion.div
			intial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<div className='news-container margin-280px'>
				<header>
					<span className='big' ref={ref} style={{ marginRight: width / 2 }}>
						{' '}
						{language == 1 ? 'სამართლებრივი აქტები' : 'LEGAL ACTS'}
					</span>

					<span>
						{menuName[1]
							? language == 1
								? menuName[1].name_geo
								: menuName[1].name_eng
							: ''}
					</span>
				</header>
				<div>
					<div className='sakrebulo-landing'>
						<div className='landing-container'>
							<div className='sajaroInfo '>
							<SakrebuloActs actsSlug={actList? actList : 'biuros-skhdomis-oqmebi'} />
							</div>
						</div>
					</div>
						<div className='presscenter-info'><SakrebuloActsList setActList={setActList}/></div>

				</div>
			</div>
		</motion.div>
	);
}

export default BiurosOqmebi;
